import { render, staticRenderFns } from "./AccountApp.vue?vue&type=template&id=a22af9cc&"
import script from "./AccountApp.vue?vue&type=script&lang=js&"
export * from "./AccountApp.vue?vue&type=script&lang=js&"
import style0 from "./AccountApp.vue?vue&type=style&index=0&id=a22af9cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports